import { render } from "./NoticeText.vue?vue&type=template&id=1f9b0fa3&scoped=true"
import script from "./NoticeText.vue?vue&type=script&lang=js"
export * from "./NoticeText.vue?vue&type=script&lang=js"

import "./NoticeText.vue?vue&type=style&index=0&id=1f9b0fa3&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9b0fa3"]])

export default __exports__